import type { ClientChannel } from "@/types"

export type ChannelPublishState =
  | "unsaved_local"
  | "never_published"
  | "unpublished"
  | "pending_publish"
  | "live"

export const deriveChannelPublishState = (
  channel: Pick<
    ClientChannel,
    "isPublished" | "lastPublishedVersion" | "publishedAt" | "updatedAt"
  >,
  hasUnsavedChanges: boolean
): ChannelPublishState => {
  if (hasUnsavedChanges) {
    return "unsaved_local"
  }

  if (!channel.isPublished && !channel.lastPublishedVersion) {
    return "never_published"
  }

  if (!channel.isPublished && channel.lastPublishedVersion) {
    return "unpublished"
  }

  if (
    channel.isPublished &&
    channel.publishedAt &&
    channel.updatedAt.getTime() > channel.publishedAt.getTime()
  ) {
    return "pending_publish"
  }

  return "live"
}
